module.exports = __webpack_public_path__ + "03_short_black.ea662128.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_short_black.png
// module id = egyn
// module chunks = 0